/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
const MoreIcon = ({ size, ...props }) => (React.createElement("svg", { viewBox: "0 0 26 6", fill: "currentColor", width: size || '26', height: size || '20', ...props },
    React.createElement("path", { fill: "currentColor", d: "M3 0a3 3 0 1 1-3 3 3 3 0 0 1 3-3zm10 0a3 3 0 1 1-3 3 3 3 0 0 1 3-3zm10 0a3 3 0 1 1-3 3 3 3 0 0 1 3-3z", fillRule: "evenodd" })));
MoreIcon.displayName = 'MoreIcon';
export default MoreIcon;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=MoreIcon.js.map